export enum Storage {
  TOKEN = "token",
  NAME = "name",
  REFRESH_TOKEN = "refresh",
  USER = "user",
  SAVED_USER = "saved_user",
  SAVED_TOKEN = "saved_token",
  SAVED_REFRESH_TOKEN = "saved_refresh_token",
}
